module.exports = __webpack_public_path__ + "static/media/woman.8e05859c.svg";